/**
 * Lookup tables + small accessors for external-document items (PDF, XLS,
 * PPT, DOC). Pure functions — no reactivity needed. Centralised here so
 * the favorites handler and any future consumers share one source of
 * truth for labels, background classes and icon classes.
 */
const LABELS = {
    pdf: 'PDF Document',
    excel: 'Excel Spreadsheet',
    powerpoint: 'PowerPoint Presentation',
    word: 'Word Document',
};

const LABELS_SHORT = {
    pdf: 'PDF',
    excel: 'XLS',
    powerpoint: 'PPT',
    word: 'DOC',
};

const BG_CLASSES = {
    pdf: 'bg-red-50 hover:bg-red-100',
    excel: 'bg-green-50 hover:bg-green-100',
    powerpoint: 'bg-orange-50 hover:bg-orange-100',
    word: 'bg-blue-50 hover:bg-blue-100',
};

const BG_BASE_CLASSES = {
    pdf: 'bg-red-50',
    excel: 'bg-green-50',
    powerpoint: 'bg-orange-50',
    word: 'bg-blue-50',
};

const ICON_CLASSES = {
    pdf: 'text-red-400',
    excel: 'text-green-500',
    powerpoint: 'text-orange-400',
    word: 'text-blue-400',
};

const TEXT_CLASSES = {
    pdf: 'text-red-500',
    excel: 'text-green-600',
    powerpoint: 'text-orange-500',
    word: 'text-blue-500',
};

const SUB_TEXT_CLASSES = {
    pdf: 'text-red-400',
    excel: 'text-green-400',
    powerpoint: 'text-orange-400',
    word: 'text-blue-400',
};

export function useDocumentTypes() {
    const documentLabel = (fileType) => LABELS[fileType] || 'Document';
    const documentLabelShort = (fileType) => LABELS_SHORT[fileType] || 'DOC';
    const documentBgClass = (fileType) => BG_CLASSES[fileType] || 'bg-gray-50 hover:bg-gray-100';
    const documentBgBaseClass = (fileType) => BG_BASE_CLASSES[fileType] || 'bg-gray-50';
    const documentIconClass = (fileType) => ICON_CLASSES[fileType] || 'text-gray-400';
    const documentTextClass = (fileType) => TEXT_CLASSES[fileType] || 'text-gray-500';
    const documentSubTextClass = (fileType) => SUB_TEXT_CLASSES[fileType] || 'text-gray-400';

    return {
        documentLabel,
        documentLabelShort,
        documentBgClass,
        documentBgBaseClass,
        documentIconClass,
        documentTextClass,
        documentSubTextClass,
    };
}
